<template>
  <div class="competition-header" v-sticky="stickyEnabled" sticky-offset="{top: 89, bottom: 0}" sticky-z-index="10">

  </div>
</template>

<script>

import sportIcon from '@/components/ui/asset/sportIcon';
export default {
  name: 'regionRow',
  components: {sportIcon},
  props: ['region', 'extendedMarkets', 'onLive'],
  data () {
    return {
      t: this.$root.t,
      stickyEnabled: true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/sportsbook/RegionRow.vue